<template>
    <div class="social-media">
        <span v-if="path != '/referral' && path != '/referral/'">
            <span v-for="item in socialMedia" :key="item.icon">
                <v-btn
                    :class="iconClass"
                    target="_blank"
                    rel="noreferrer"
                    icon
                    aria-label="social_media"
                    @click="openNetwork(item.link)"
                >
                    <v-avatar :size="size">
                        <img
                            :src="`${CDN_IMG_URL}/social-media/${item.icon}.svg`"
                            :alt="item.alt"
                            :width="size"
                            :height="size"
                        />
                    </v-avatar>
                </v-btn>
            </span>
        </span>
        <span v-else>
            <span v-for="item in networks" :key="item.icon">
                <ShareNetwork
                    class="ma-1"
                    :network="item"
                    :url="profile.referalLink"
                    title=""
                    description=""
                    :quote="`${domainType} - the world's first official betting website aggregator.`"
                    :hashtags="`${domainType}`"
                >
                    <v-avatar :size="size">
                        <img
                            :src="`${CDN_IMG_URL}/social-media/${item}.svg`"
                            :alt="item.alt"
                            :width="size"
                            :height="size"
                        />
                    </v-avatar>
                </ShareNetwork>
            </span>
        </span>

        <v-btn
            v-if="path == '/referral' || path == '/referral/'"
            ref="instagram"
            class="ma-1"
            :class="iconClass"
            target="_blank"
            rel="noreferrer"
            icon
            aria-label="social_media"
            @click="openNetwork('https://www.instagram.com/')"
        >
            <v-avatar :size="size">
                <img
                    :src="`${CDN_IMG_URL}/social-media/instagram.svg`"
                    alt="instagram"
                    :width="size"
                    :height="size"
                />
            </v-avatar>
        </v-btn>
        <span
            v-if="
                getWhatsappData &&
                getWhatsappData.isWhatsAppNo &&
                getWhatsappData.number &&
                getWhatsappData.whatsAppLink &&
                path != '/referral' &&
                path != '/referral/'
            "
        >
            <v-btn
                :class="iconClass"
                target="_blank"
                rel="noreferrer"
                icon
                :href="getWhatsappData.whatsAppLink"
            >
                <!-- :href="`https://api.whatsapp.com/send?phone=${getWhatsappData.number}`" -->
                <v-avatar :size="size">
                    <img
                        :src="`${CDN_IMG_URL}/social-media/whatsapp.svg`"
                        alt="whatsapp"
                        :width="size"
                        :height="size"
                    />
                </v-avatar>
            </v-btn>
        </span>
    </div>
</template>

<script>
import { mapState } from "vuex"
export default {
    props: {
        size: { type: [String, Number], required: true },
        iconClass: { type: String, required: true }
    },
    data() {
        return {
            domainType: process.env.APP_TITLE,
            CDN_IMG_URL: process.env.CDN_IMG_URL,
            path: "",
            networks: ["facebook", "twitter", "telegram", "whatsapp"],
            socialMedia: [
                {
                    icon: "facebook",
                    alt: "Facebook",
                    link: process.env.FACEBOOK_URL
                },
                {
                    icon: "twitter",
                    alt: "Twitter",
                    link: process.env.TWITTER_URL
                },
                {
                    icon: "telegram",
                    alt: "Telegram",
                    link: process.env.TELEGRAM_URL
                },
                {
                    icon: "instagram",
                    alt: "Instagram",
                    link: process.env.INSTAGRAM_URL
                },
                {
                    icon: "youtube",
                    alt: "Youtube",
                    link: process.env.YOUTUBE_URL
                }
                // {
                //     icon: "linkedin",
                //     alt: "Linkedin",
                //     link: process.env.LINKEDIN_URL
                // }
            ]
        }
    },
    computed: {
        ...mapState({
            getWhatsappData: (state) => state.user.whatsappData
        }),
        profile() {
            return this.$store.state.profile.data
        }
    },
    created() {
        this.path = this.$route.path
    },
    methods: {
        openNetwork(link) {
            if (process.client) {
                window.open(link)
            }
        }
    }
}
</script>

<style scoped>
/* .social-media a {
  margin-left: -3px;
} */
</style>
